<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="oneway_search_form">
                <form action="#!">
                    <div class="multi_city_form_wrapper">
                        <div class="multi_city_form">
                            <div class="row">
                                <div class="col-lg-3 col-md-6 col-sm-12 col-12 relative">
                                    <div class="flight_Search_boxed">
                                        <p>{{ $t('From') }}</p>
                                        <input type="text" class="departure" v-model="multi_city[0].from"
                                            name="departure" :placeholder="$t('City or Airport')"
                                            @input="handle_airports_search_multi_city(multi_city[0].from, 'departure', 0)"
                                            autocomplete="off">
                                        <span class="departure_name">
                                            {{ airport_name_multi[0]['departure'] }}
                                        </span>
                                        <div class="plan_icon_posation">
                                            <i class="fas fa-plane-departure"></i>
                                        </div>
                                    </div>
                                    <ul v-if="is_searching_multi[0]['departure']" tabindex="0"
                                        class="ui-id-1 ui-menu ui-widget ui-widget-content ui-autocomplete ui-front"
                                        style="top: 110px;z-index: 1060;left: 0px;text-align: initial;right: 0;">
                                        <li class="fl-route-list ui-autocomplete-category ui-state-disabled ui-menu-item"
                                            aria-disabled="true">
                                            <a class="fl-routes ui-menu-item-wrapper" id="ui-id-8" tabindex="-1">
                                                {{ $t('Nearest airport') }}
                                            </a>
                                        </li>
                                        <li v-for="airport in airports_data" class="fl-route-list ui-menu-item"
                                            @click="selectAirportMultiCity(airport, 0, 'departure')">
                                            <a class="fl-routes ui-menu-item-wrapper" tabindex="-1">
                                                <div class="inline-block airportMargin">
                                                    <span class="fl-loc">
                                                        {{ airport[this.$i18n.locale
                                                            + '_name'] }}
                                                    </span>
                                                    <span class="fl-country">
                                                        {{ airport[this.$i18n.locale
                                                            + '_city'] }}
                                                        ,
                                                        {{ airport[this.$i18n.locale
                                                            + '_country'] }}
                                                    </span>
                                                </div>
                                                <div class="pull-right">
                                                    <h4 class="fl-route-code">
                                                        {{ airport.code }}
                                                    </h4>
                                                </div>
                                            </a>
                                        </li>
                                        <li v-if="noResults" class="fl-route-list ui-menu-item no-results">
                                            {{ $t('No results!') }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-12 col-12 relative">
                                    <div class="flight_Search_boxed">
                                        <p>{{ $t('To') }}</p>
                                        <input type="text" class="arrival" name="arrival" v-model="multi_city[0].to"
                                            @input="handle_airports_search_multi_city(multi_city[0].to, 'arrival', 0)"
                                            :placeholder="$t('City or Airport')" readonly>
                                        <span class="arrival_name">{{
                                            airport_name_multi[0]['arrival']
                                            }}</span>
                                        <div class="plan_icon_posation">
                                            <i class="fas fa-plane-arrival"></i>
                                        </div>
                                        <div class="range_plan">
                                            <i class="fas fa-exchange-alt"></i>
                                        </div>
                                    </div>
                                    <ul v-if="is_searching_multi[0]['arrival']" tabindex="0"
                                        class="ui-id-1 ui-menu ui-widget ui-widget-content ui-autocomplete ui-front"
                                        style="top: 110px;z-index: 1060;left: 0px;text-align: initial;right: 0;">
                                        <li class="fl-route-list ui-autocomplete-category ui-state-disabled ui-menu-item"
                                            aria-disabled="true">
                                            <a class="fl-routes ui-menu-item-wrapper" id="ui-id-8" tabindex="-1">
                                                {{ $t('Nearest airport') }}
                                            </a>
                                        </li>
                                        <li v-for="airport in airports_data" class="fl-route-list ui-menu-item"
                                            @click="selectAirportMultiCity(airport, 0, 'arrival')">
                                            <a class="fl-routes ui-menu-item-wrapper" tabindex="-1">
                                                <div class="inline-block airportMargin">
                                                    <span class="fl-loc">
                                                        {{
                                                            airport[this.$i18n.locale +
                                                            '_name'] }}
                                                    </span>
                                                    <span class="fl-country">
                                                        {{
                                                            airport[this.$i18n.locale +
                                                            '_city'] }}
                                                        ,
                                                        {{
                                                            airport[this.$i18n.locale +
                                                            '_country'] }}
                                                    </span>
                                                </div>
                                                <div class="pull-right">
                                                    <h4 class="fl-route-code">{{
                                                        airport.code }}
                                                    </h4>
                                                </div>
                                            </a>
                                        </li>
                                        <li v-if="noResults" class="fl-route-list ui-menu-item no-results">
                                            {{ $t('No results!') }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                                    <div class="form_search_date">
                                        <div class="flight_Search_boxed">
                                            <div class="Journey_date">
                                                <p>{{ $t('Departure Date') }}</p>
                                                <VueDatePicker v-model="multi_city[0].date" :enable-time-picker="false"
                                                    :min-date="departure_min_date" :max-date="departure_max_date"
                                                    :start-date="departure_min_date"
                                                    @internal-model-change="handleInternalMultiCity"
                                                    :placeholder="$t('Departure Date')" prevent-min-max-navigation />
                                                <span class="departure_day">
                                                    {{ this.multi_city[0].date ?
                                                        $t(new
                                                            Date(multi_city[0].date).toLocaleDateString('en-US',
                                                                { weekday: 'long' })) : '' }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-1  col-md-6 col-sm-12 col-12 p-r-0">
                                    <div class="flight_Search_boxed dropdown_passenger_area">
                                        <p>{{ $t('Passengers') }}</p>
                                        <div class="dropdown">
                                            <button class="dropdown-toggle final-count" type="button">
                                                {{ number }} {{ $t('passenger') }}
                                            </button>
                                        </div>
                                    </div>
                                    <div v-if="guest_id && companions.length > 0 && is_self_paying == 0"
                                        class="form-group check-companion">
                                        <label class="form-check-label">
                                            <span class="area_flex_one">
                                                <div class="ripple-checkbox-primary">
                                                    <input class="inp-cbx" id="booking-companion-3" type="checkbox"
                                                        v-model="booking_for_companion"
                                                        @change="handle_booking_for_companion" style="display: none">
                                                    <label class="cbx" for="booking-companion-3">
                                                        <span>
                                                            <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                                <polyline points="1.5 6 4.5 9 10.5 1">
                                                                </polyline>
                                                            </svg>
                                                        </span>
                                                    </label>
                                                </div>
                                                <span class="p-0 pl-2 pr-2">
                                                    {{ $t('booking for companion as well') }}
                                                </span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-lg-1  col-md-6 col-sm-12 col-12 p-r-0 ">
                                    <div class="flight_Search_boxed dropdown_passenger_area">
                                        <p>{{ $t('Class') }} </p>
                                        <div class="dropdown">
                                            <button v-if="allowedDegree.length > 1" class="dropdown-toggle final-count"
                                                data-toggle="dropdown" type="button" id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                                {{ $t(cabin) }}
                                            </button>
                                            <button v-else class="dropdown-toggle final-count" type="button">
                                                {{ $t(cabin) }}
                                            </button>
                                            <div v-if="allowedDegree.length > 1"
                                                class="dropdown-menu dropdown_passenger_info"
                                                aria-labelledby="dropdownMenuButton1">
                                                <div class="traveller-calulate-persons">
                                                    <div class="cabin-selection">
                                                        <h6>
                                                            {{ $t('Cabin Class') }}
                                                        </h6>
                                                        <div class="cabin-list">
                                                            <button v-if="allowedDegree.includes('economy')"
                                                                type="button" class="label-select-btn">
                                                                <input id="cb-eco" type="radio" v-model="cabin"
                                                                    name="cabin" value="ECONOMY" class="chk-cabin">
                                                                <label for="cb-eco">
                                                                    <span class="muiButton-label">
                                                                        {{ $t('ECONOMY') }}
                                                                    </span>
                                                                </label>
                                                            </button>
                                                            <button v-if="allowedDegree.includes('business')"
                                                                type="button" class="label-select-btn">
                                                                <input id="cb-bus" type="radio" v-model="cabin"
                                                                    name="cabin" value="BUSINESS" class="chk-cabin">
                                                                <label for="cb-bus">
                                                                    <span class="muiButton-label">
                                                                        {{ $t('BUSINESS') }}
                                                                    </span>
                                                                </label>
                                                            </button>
                                                            <button v-if="allowedDegree.includes('first class')"
                                                                type="button" class="label-select-btn">
                                                                <input id="cb-firs" type="radio" v-model="cabin"
                                                                    name="cabin" value="FIRST" class="chk-cabin">
                                                                <label for="cb-firs">
                                                                    <span class="muiButton-label">
                                                                        {{ $t('FIRST') }}
                                                                    </span>
                                                                </label>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-for='(rowDat, index) in rowData'>
                        <div class="multi_city_form">
                            <div class="row">
                                <div class="col-lg-3 relative">
                                    <div class="flight_Search_boxed">
                                        <p>{{ $t('From') }}</p>
                                        <input type="text" class="departure" name="departure"
                                            v-model="multi_city[index + 1].from"
                                            @input="handle_airports_search_multi_city(multi_city[index + 1].from, 'departure', index + 1)"
                                            :placeholder="$t('City or Airport')" autocomplete="off"
                                            :readonly="index == 0 ? true : false">
                                        <span class="departure_name">{{
                                            airport_name_multi[index +
                                            1]['departure']
                                        }}</span>
                                        <div class="plan_icon_posation">
                                            <i class="fas fa-plane-departure"></i>
                                        </div>
                                    </div>
                                    <ul v-if="is_searching_multi[index + 1]['departure']" tabindex="0"
                                        class="ui-id-1 ui-menu ui-widget ui-widget-content ui-autocomplete ui-front"
                                        style="top: 110px;z-index: 1060;left: 0px;text-align: initial;right: 0;">
                                        <li class="fl-route-list ui-autocomplete-category ui-state-disabled ui-menu-item"
                                            aria-disabled="true">
                                            <a class="fl-routes ui-menu-item-wrapper" id="ui-id-8" tabindex="-1">
                                                {{ $t('Nearest airport') }}
                                            </a>
                                        </li>
                                        <li v-for="airport in airports_data" class="fl-route-list ui-menu-item"
                                            @click="selectAirportMultiCity(airport, index + 1, 'departure')">
                                            <a class="fl-routes ui-menu-item-wrapper" tabindex="-1">
                                                <div class="inline-block airportMargin">
                                                    <span class="fl-loc">
                                                        {{
                                                            airport[this.$i18n.locale +
                                                            '_name'] }}
                                                    </span>
                                                    <span class="fl-country">
                                                        {{
                                                            airport[this.$i18n.locale +
                                                            '_city'] }}
                                                        ,
                                                        {{
                                                            airport[this.$i18n.locale +
                                                            '_country'] }}
                                                    </span>
                                                </div>
                                                <div class="pull-right">
                                                    <h4 class="fl-route-code">
                                                        {{ airport.code }}
                                                    </h4>
                                                </div>
                                            </a>
                                        </li>
                                        <li v-if="noResults" class="fl-route-list ui-menu-item no-results">
                                            {{ $t('No results!') }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-lg-3 relative">
                                    <div class="flight_Search_boxed">
                                        <p>{{ $t('To') }}</p>
                                        <input type="text" class="arrival" name="arrival"
                                            v-model="multi_city[index + 1].to"
                                            @input="handle_airports_search_multi_city(multi_city[index + 1].to, 'arrival', index + 1)"
                                            :placeholder="$t('City or Airport')" autocomplete="off">
                                        <span class="arrival_name">{{
                                            airport_name_multi[index + 1]['arrival']
                                            }}</span>
                                        <div class="plan_icon_posation">
                                            <i class="fas fa-plane-arrival"></i>
                                        </div>
                                        <div class="range_plan">
                                            <i class="fas fa-exchange-alt"></i>
                                        </div>
                                    </div>
                                    <ul v-if="is_searching_multi[index + 1]['arrival']" tabindex="0"
                                        class="ui-id-1 ui-menu ui-widget ui-widget-content ui-autocomplete ui-front"
                                        style="top: 110px;z-index: 1060;left: 0px;text-align: initial;right: 0;">
                                        <li class="fl-route-list ui-autocomplete-category ui-state-disabled ui-menu-item"
                                            aria-disabled="true">
                                            <a class="fl-routes ui-menu-item-wrapper" id="ui-id-8" tabindex="-1">
                                                {{ $t('Nearest airport') }}
                                            </a>
                                        </li>
                                        <li v-for="airport in airports_data" class="fl-route-list ui-menu-item"
                                            @click="selectAirportMultiCity(airport, index + 1, 'arrival')">
                                            <a class="fl-routes ui-menu-item-wrapper" tabindex="-1">
                                                <div class="inline-block airportMargin">
                                                    <span class="fl-loc">
                                                        {{
                                                            airport[this.$i18n.locale +
                                                            '_name']
                                                        }}
                                                    </span>
                                                    <span class="fl-country">
                                                        {{
                                                            airport[this.$i18n.locale +
                                                            '_city']
                                                        }} ,
                                                        {{
                                                            airport[this.$i18n.locale +
                                                            '_country']
                                                        }}
                                                    </span>
                                                </div>
                                                <div class="pull-right">
                                                    <h4 class="fl-route-code">
                                                        {{ airport.code }}
                                                    </h4>
                                                </div>
                                            </a>
                                        </li>
                                        <li v-if="noResults" class="fl-route-list ui-menu-item no-results">
                                            {{ $t('No results!') }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form_search_date">
                                        <div class="flight_Search_boxed">
                                            <div class="Journey_date">
                                                <p>{{ $t('Departure Date') }}</p>
                                                <VueDatePicker v-model="multi_city[index + 1].date"
                                                    :enable-time-picker="false" :min-date="arrival_min_date"
                                                    :max-date="arrival_max_date" :start-date="arrival_min_date"
                                                    @internal-model-change="handleInternalMultiCity"
                                                    :placeholder="$t('Departure Date')" prevent-min-max-navigation />
                                                <span class="departure_day">
                                                    {{ this.multi_city[index +
                                                        1].date ? $t(new
                                                            Date(multi_city[index +
                                                                1].date).toLocaleDateString('en-US',
                                                                    { weekday: 'long' })) : '' }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="top_form_search_button">
                        <button type="button" class="btn btn_theme btn_md btn-search-flight-next" @click="search">
                            {{ $t('Search Flight') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery';
import { debounce } from 'lodash';
import { toast } from 'vue3-toastify';
import jsonData from '@/assets/file/airports-v2.json';
import { dateDiffInDays, diffYears } from '@/utils/dateUtils';

export default {
    name: "MultiCitySearchForm",
    props: [
        'departure_min_date',
        'departure_max_date',
        'arrival_min_date',
        'arrival_max_date',
        'companions',
        'guest_id',
        'is_self_paying',
        'allowedDegree',
        'max_free_period_between_arrival_departure',
        'view'
    ],
    data() {
        return {
            multi_city: [
                {
                    from: '',
                    to: '',
                    date: null,
                },
                {
                    from: '',
                    to: '',
                    date: null,
                }
            ],
            airport_name_multi: [
                { departure: '', arrival: '', },
                { departure: '', arrival: '', }
            ],
            is_searching_multi: [
                { departure: false, arrival: false, },
                { departure: false, arrival: false, }
            ],
            noResults: false,
            airports_data: [],
            rowData: [{ name: '' }],
            cabin: 'ECONOMY',
            number: 1,
            pnumber: 1,
            cnumber: 0,
            inumber: 0,
            booking_for_companion: false,
            main_airport: {
                code: "RUH",
                ar_name: "مطار الملك خالد الدولي",
                en_name: "King Khalid Intl",
            },
        }
    },
    watch: {
        'allowedDegree': {
            handler() {
                var tripType = localStorage.getItem("tripType");
                if (this.view == 'result' && tripType == 'multi_city') {
                    this.booking_for_companion = this.number > 1 ? true : false;
                    return;
                }
                if (this.allowedDegree.includes('business')) {
                    this.cabin = 'BUSINESS';
                } else if (this.allowedDegree.includes('economy')) {
                    this.cabin = 'ECONOMY';
                } else if (this.allowedDegree.includes('first class')) {
                    this.cabin = 'FIRST';
                }
            },
            deep: true
        },
        'companions': {
            handler() {
                if (this.is_self_paying == 1 || !this.guest_id) {
                    if (this.is_self_paying == 0) {
                        this.number = 0;
                        this.pnumber = 0;
                    }
                    this.companions.forEach(element => {
                        if (element.data_status == "Complete" && !element.flight) {
                            var dt1 = new Date(element.birthdate);
                            var dt2 = new Date();
                            var interval = this.diff_years(dt1, dt2);
                            if (interval <= 2) {
                                this.inumber += 1;
                            } else if (interval <= 11) {
                                this.cnumber += 1;
                            } else {
                                this.pnumber += 1;
                            }
                            this.number += 1;
                        }
                    });
                }
            },
            deep: true
        },
    },
    methods: {
        diff_years(dt2, dt1) {
            return diffYears(dt2, dt1);
        },
        handle_booking_for_companion() {
            if (this.booking_for_companion) {
                this.companions.forEach(element => {
                    if (element.data_status != 'Complete' && !element.flight) {
                        this.number = 1;
                        this.booking_for_companion = false;
                        toast.error(this.$t('You have to complete your companion information'), {
                            autoClose: 3500,
                            position: toast.POSITION.TOP_CENTER,
                            closeButton: false
                        });
                        return;
                    } else if (element.data_status == "Complete" && !element.flight) {
                        var dt1 = new Date(element.birthdate);
                        var dt2 = new Date();
                        var interval = this.diff_years(dt1, dt2);
                        if (interval <= 2) {
                            this.inumber += 1;
                        } else if (interval <= 11) {
                            this.cnumber += 1;
                        } else {
                            this.pnumber += 1;
                        }
                        this.number += 1;
                    }
                });
            } else {
                this.number = 1;
                this.pnumber = 1;
                this.cnumber = 0;
                this.inumber = 0;
            }
        },
        handle_airports_search_multi_city: debounce(function (val, type, index) {
            this.searchAirPortsMultiCity(val, type, index);
        }, 500),
        searchAirPortsMultiCity(val, type, index) {
            this.noResults = false;
            if (val == '') {
                this.is_searching_multi[index][type] = false;
                return;
            } else {
                this.is_searching_multi[index][type] = true;
            }
            this.airports_data = jsonData.filter(item => {
                if (item.ar_name == null ||
                    item.code == null ||
                    item.ar_city == null ||
                    item.ar_state == null ||
                    item.ar_country == null ||
                    item.en_name == null ||
                    item.en_city == null ||
                    item.en_state == null ||
                    item.en_country == null) {
                    return false;
                } else {
                    return item.ar_name.toLowerCase().includes(val.toLowerCase()) ||
                        item.code.toLowerCase().includes(val.toLowerCase()) ||
                        item.ar_city.toLowerCase().includes(val.toLowerCase()) ||
                        item.ar_state.toLowerCase().includes(val.toLowerCase()) ||
                        item.ar_country.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_name.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_city.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_state.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_country.toLowerCase().includes(val.toLowerCase());
                }

            });
            if (this.airports_data.length == 0) {
                this.noResults = true;
            }
        },
        selectAirportMultiCity(data, index, type) {
            this.is_searching_multi[index][type] = false;
            this.airport_name_multi[index][type] = data[this.$i18n.locale + '_name'];
            if (type == 'departure') {
                this.multi_city[index]['from'] = data['code'];
            } else {
                this.multi_city[index]['to'] = data['code'];
            }
        },
        handleInternalMultiCity(date) {
            setTimeout(() => {
                $(document).find('.dp__action_select').click();
            }, 10);
        },
        dateDiffInDays(date1, date2) {
            return dateDiffInDays(date1, date2);
        },
        search() {
            var locationValid = true, dateValid = true;
            const differenceInDays = this.dateDiffInDays(
                new Date(this.multi_city[0].date),
                new Date(this.multi_city[1].date)
            );
            $.each(this.multi_city, function (index, city) {
                if (city.from.trim() === '' || city.to.trim() === '') {
                    locationValid = false;
                    return false;
                }
            });
            $.each(this.multi_city, function (index, city) {
                if (!city.date) {
                    dateValid = false;
                    return false;
                }
            });
            if (differenceInDays > this.max_free_period_between_arrival_departure) {
                toast.error(this.$t('The maximum period between the date of arrival and departure must not exceed') + this.max_free_period_between_arrival_departure + ' ' + this.$t('day'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            } else if (!locationValid) {
                toast.error(this.$t('Invalid Location'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            } else if (!dateValid) {
                toast.error(this.$t('Invalid Date'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            } else {
                var info = ``;
                $.each(this.multi_city, function (index, item) {
                    info += `&from[]=${item.from}`;
                });
                $.each(this.multi_city, function (index, item) {
                    info += `&to[]=${item.to}`;
                });
                $.each(this.multi_city, function (index, item) {
                    info += `&date[]=${new Date(item.date).toLocaleDateString('sv-SE')}`;
                });
                var data = {
                    "currency": 'SAR',
                    "adults": this.pnumber,
                    "children": this.cnumber,
                    "infants": this.inumber,
                    "cabin": this.cabin,
                    "info": info,
                    "type": 'multi_city'
                };
                this.$emit('search', data);
            }
        }
    },
    mounted() {
        this.multi_city[0]['to'] = this.main_airport.code;
        this.airport_name_multi[0]['arrival'] = this.main_airport[this.$i18n.locale + '_name'];
        this.multi_city[1]['from'] = this.main_airport.code;
        this.airport_name_multi[1]['departure'] = this.main_airport[this.$i18n.locale + '_name'];
        var searchData = JSON.parse(localStorage.getItem("searchData"));
        var tripType = localStorage.getItem("tripType");
        var is_self_paying = localStorage.getItem("is_self_paying");
        if (this.view == 'result' && tripType == 'multi_city') {
            if (is_self_paying == 0) {
                this.pnumber = parseInt(searchData.adults);
                this.cnumber = parseInt(searchData.children);
                this.inumber = parseInt(searchData.infants);
                this.number = this.pnumber + this.cnumber + this.inumber;
            }
            this.cabin = searchData.cabin;

            const params = new URLSearchParams(searchData.info);
            var from = params.getAll('from[]'),
                to = params.getAll('to[]'),
                date = params.getAll('date[]');

            from.forEach((item, index) => {
                this.multi_city[index] = {
                    from: item,
                    to: to[index],
                    date: date[index],
                };
                this.is_searching_multi[index] = { departure: false, arrival: false, };
                var departure = jsonData.filter(val => {
                    return val.code.includes(item);
                });
                var arrival = jsonData.filter(val => {
                    return val.code.includes(to[index]);
                });
                this.airport_name_multi[index] = { departure: departure[0][this.$i18n.locale + '_name'], arrival: arrival[0][this.$i18n.locale + '_name'], };
            });
        }
    }
};
</script>